import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

class GcsClient {
  async getSignedUrl(fileName: string, fileType: string, token: string): Promise<string> {
    const response = await axios.post(
      `${API_URL}gcs/signed-url`,
      {
        fileName,
        fileType,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return response.data.url
  }

  async uploadToSignedUrl(signedUrl: string, file: File): Promise<void> {
    const response = await axios({
      method: 'PUT',
      url: signedUrl,
      data: file,
      headers: {
        'Content-Type': file.type,
      },
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    })

    if (response.status !== 200) {
      throw new Error(`Upload failed with status ${response.status}`)
    }
  }
}

export default new GcsClient()
